<template>
  <div>
    <v-layout wrap>
      <v-flex xs8>
        <draggable
          v-model="items"
          v-bind="dragOptions"
          @start="drag = true"
          @end="drag = false"
          tag="ul"
          class="list-group"
        >
          <transition-group type="transition" :name="!drag ? 'flip-list' : null">
            <v-card v-for="(item, itemIndex) in items" :key="item.idInLoop" class="list-group-item px-2 py-2 mb-4">
              <i @click="item.fixed = !item.fixed" :class="item.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'" aria-hidden="true"></i>
              <v-layout wrap>
                <v-flex xs2>
                  <v-container fill-height fluid class="py-0">
                    <v-row align="center" justify="center" class="py-0">
                      <v-col class="py-0">
                        <div class="mb-1">
                          <v-btn fab @click="moveUp(itemIndex)" x-small elevation="0" v-if="itemIndex !== 0">
                            <v-icon small>mdi-arrow-up</v-icon>
                          </v-btn>
                          <div v-else style="padding-top:32px"></div>
                        </div>
                        <div class="mt-1">
                          <v-btn fab @click="moveDown(itemIndex)" x-small elevation="0" v-if="itemIndex !== items.length-1">
                            <v-icon small>mdi-arrow-down</v-icon>
                          </v-btn>
                          <div v-else style="padding-top:32px"></div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-flex>
                <v-flex xs2>
                  <v-container fill-height fluid py-0>
                    <v-row align="center" justify="center">
                      <v-col>
                        <v-icon style="cursor:move">mdi-drag-vertical</v-icon>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-flex>
                <v-flex xs8>
                  <small>
                    <div v-if="item.startYear || item.endYear"><b>{{ [item.startYear, item.endYear].filter(x => !!x).join(' - ') }}</b></div>
                    <div>{{ item.institute }}</div>
                    <div>{{ item.description }}</div>
                  </small>
                </v-flex>
              </v-layout>
            </v-card>
          </transition-group>
        </draggable>
      </v-flex>
      <v-flex xs4 text-center>
        <div class="mb-6">
          <v-btn @click="saveAndClose" small class="secondary">
            {{ $t('a') }}
          </v-btn>
        </div>
        <div>
          <v-btn @click="closeWithoutSaving" small outlined>
            {{ $t('b') }}
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  props: {
    certifications: Array
  }, 
  order: 7,
  components: {
    draggable
  },
  data: () => ({
    drag: false,
    items: []
  }),
  mounted() {
    this.items = JSON.parse(JSON.stringify(this.certifications)).map((item, index) => {
      // Add an id, to have a smooth behavior when moving up or down an item
      item.idInLoop = index
      return item
    })
  },
  methods: {
    moveUp(index) {
      this.arraymove(this.items, index, index-1)
    },
    moveDown(index) {
      this.arraymove(this.items, index, index+1)
    },
    arraymove(arr, fromIndex, toIndex) {
      const element = arr[fromIndex];
      arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, element);
    },
    saveAndClose() {
      this.$emit('updateCertificationsOrder', this.items.map(item => {
        delete item.idInLoop
        return item
      }))
    },
    closeWithoutSaving() {
      this.$emit('updateCertificationsOrder', this.certifications)
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  }
};
</script>

<style scoped>
.button {
  margin-top: 35px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}
</style>


<i18n>
{
  "fr": {
    "a": "Sauvegarder",
    "b": "Annuler"
  },
  "en": {
    "a": "Save",
    "b": "Cancel"
  }
}
</i18n>